import { QueryHookOptions, useQuery } from '@apollo/client';

import { FIND_BY_ID_QUERY_FOR_PARENT_STATUSES } from './queries';
import type { ParentFormStatusesDto } from './types';

export const useParentFormsStatuses = (id: number | null, options?: QueryHookOptions) =>
  useQuery<{ findParentFormsStatuses: ParentFormStatusesDto }>(FIND_BY_ID_QUERY_FOR_PARENT_STATUSES, { ...options, variables: { id }, skip: !id });
